document.addEventListener("DOMContentLoaded", function () {
    const hero_logo_sentinel = document.querySelector("#hero-home-logo .ctn_img .sentinel");
    const header_logo = document.getElementById("header-logo");
    const header = document.querySelector(".ctn_header");
    
    if (hero_logo_sentinel) {
        let logoAnimationActive = false;
        let animationStartScroll = null;

        const showLogo = (entries) => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                header_logo.classList.add('show');
                logoAnimationActive = true;
                animationStartScroll = window.scrollY;
                animateLogoOnScroll();
              } else {
                header_logo.classList.remove('show');
                logoAnimationActive = false;
                animationStartScroll = null;
                header_logo.style.transform = `translateY(200%) scale(2.8)`;
              }
            });
        };

        function animateLogoOnScroll() {
            if (!logoAnimationActive || animationStartScroll === null) return;
            
            const scroll = window.scrollY;
            const heroImage = document.querySelector('.ctn_img');
            
            if (!heroImage) {
                // Fallback animation - slower transition
                const scrollDistance = scroll - animationStartScroll;
                const progress = Math.min((scrollDistance * 0.15) / 1000, 1); // Reduced from 0.3 to 0.15
                const translateYPercent = 200 - (progress * 200);
                const scale = 2.8 - (progress * 1.8);
                header_logo.style.transform = `translateY(${translateYPercent}%) scale(${scale})`;
                header_logo.style.transition = 'transform 0.1s ease-out'; // Added smooth transition
                requestAnimationFrame(animateLogoOnScroll);
                return;
            }
            
            // Get positions
            const heroRect = heroImage.getBoundingClientRect();
            const headerRect = header_logo.closest('.section_new_header').getBoundingClientRect();
            
            const heroTop = heroRect.top;
            const heroHeight = heroRect.height;
            const headerBottom = headerRect.bottom;
            
            // Calculate hero hiding progress behind header
            const intersectionStart = headerBottom;
            const heroHidingProgress = Math.max(0, Math.min(1, (intersectionStart - heroTop) / heroHeight));
            
            // Animation values - smoother transition
            const easeProgress = heroHidingProgress * heroHidingProgress * (3 - 2 * heroHidingProgress); // Smooth step function
            const translateYPercent = 200 - (easeProgress * 200);
            const scale = 2.8 - (easeProgress * 1.8);
            
            header_logo.style.transform = `translateY(${translateYPercent}%) scale(${scale})`;
            header_logo.style.transition = 'transform 0.3s ease-out'; // Added smooth transition
            requestAnimationFrame(animateLogoOnScroll);
        }

        const openHeader = (entries) => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                header_logo.classList.add('open');
                header.classList.add('open');
              } else {
                header_logo.classList.remove('open');
                header.classList.remove('open');
              }
            });
        };
    
        const showObserver = new IntersectionObserver(showLogo, {
          root: null,
          rootMargin: '-65px 0px 0px 0px',
        });

        const openObserver = new IntersectionObserver(openHeader, {
          root: null,
          rootMargin: '-93px 0px 0px 0px',
        });

        showObserver.observe(hero_logo_sentinel);
        openObserver.observe(hero_logo_sentinel);
    } else {
      header_logo.classList.add('show');
      header_logo.classList.add('open');
      header.classList.add('open');
    }
});